import { useCallback, useContext, useEffect } from 'react';
import {
    ActionDependant,
    evaluateTemplateValue,
    GlobalDataContext,
    TemplateContext,
} from '@ea-lab/reactive-json';
import DocAccessPanel from './DocAccessPanel';
import { ShieldCheck, X } from 'lucide-react';

export const DocAccessManager = ({ props }) => {
    const globalDataContext = useContext(GlobalDataContext);
    const templateContext = useContext(TemplateContext);

    const ev = (val) => evaluateTemplateValue({ valueToEvaluate: val, templateContext, globalDataContext });

    const isOpen = ev(props.isOpen);
    const directoryId = ev(props.directoryId);
    const directoryName = ev(props.directoryName) || '';
    const openPath = props.openPath || 'showAccessManager';

    const handleClose = useCallback(() => {
        globalDataContext.updateData(false, openPath);
    }, [globalDataContext, openPath]);

    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e) => { if (e.key === 'Escape') handleClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [isOpen, handleClose]);

    if (!isOpen) return null;

    return (
        <ActionDependant {...props}>
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true">
                <div className="fixed inset-0 bg-black/20 backdrop-blur-sm" onClick={handleClose} />
                <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl border border-stone-200 max-h-[85vh] flex flex-col">
                    <div className="flex items-center justify-between px-6 py-4 border-b border-stone-200 flex-shrink-0">
                        <div className="flex items-center gap-2.5 min-w-0">
                            <ShieldCheck size={18} className="text-blue-600 flex-shrink-0" />
                            <h2 className="text-lg font-semibold text-stone-900 truncate">
                                Accès — {directoryName || '…'}
                            </h2>
                        </div>
                        <button onClick={handleClose} className="p-1 rounded-lg hover:bg-stone-100 text-stone-400 transition-colors" aria-label="Fermer">
                            <X size={18} />
                        </button>
                    </div>
                    <div className="flex-1 overflow-y-auto px-6 py-5">
                        <DocAccessPanel
                            directoryId={directoryId}
                            isActive={isOpen}
                            onSaved={handleClose}
                        />
                    </div>
                </div>
            </div>
        </ActionDependant>
    );
};
